import { TicketsPage } from '@pages/Admin/ErrorTickets/pages/TicketsPage';

export const DashboardCriticalTickets = () => {
  return <TicketsPage ticketType={4} />;
};
